import React, { useEffect, useState, useCallback, useMemo } from 'react';
import Carousel, { Modal, ModalGateway } from "react-images";
// import { Carousel } from 'react-responsive-carousel';

import {
    ReactPhotoCollageComponent,
} from './react-photo-collage-component';

const createPhotoIds = (photos) => {
    return photos.map((data, i) => {
        return { ...data, id: i }
    });
}

const createLayoutPhotoMaps = (layout, photos) => {
    const newPhotos = createPhotoIds(photos);
    const newMaps = {};
    layout.reduce((accumulator, currentValue, currentIndex) => {
        newMaps[currentIndex] = newPhotos.slice(accumulator, accumulator + currentValue);
        return accumulator + currentValue;
    }, 0);

    return newMaps;
}

const checkProps = (props) => {
    const defaultProps = {
        width: '800px',
        height: new Array(props.layout.length),
        layout: [],
        photos: [],
        showNumOfRemainingPhotos: false
    }
    const newProps = { ...defaultProps, ...props };
    if (newProps.height.length < newProps.layout.length) {
        for (let i = 0; i < newProps.layout.length; i++) {
            newProps.height[i] = '200px';
        }
    }
    return newProps;
}

const ReactPhotoCollageContainer = (props) => {
    const currProps = useMemo(() => checkProps(props), [props]);
    const { width, height, layout, photos, showNumOfRemainingPhotos } = currProps;
    const layoutNum = layout.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    const remainingNum = photos.length - layoutNum;
    const [allowRender, setAllowRender] = useState(false);
    const [layoutPhotoMaps, setLayoutPhotoMaps] = useState({});
    const [viewerIsOpen, setViewerIsOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState(0);

    useEffect(() => {
        setLayoutPhotoMaps(createLayoutPhotoMaps(layout, photos));
    }, []);
    useEffect(() => {
        Object.keys(layoutPhotoMaps).length ? setAllowRender(true) : setAllowRender(false);
    }, [layoutPhotoMaps]);

    const openLightbox = useCallback((id) => {
        setCurrentImage(parseInt(id));
        setViewerIsOpen(true);
        console.log("OPENING CAROSEL on id: " + id + " show lightbox: " + viewerIsOpen);
    }, []);
    const closeLightbox = useCallback(() => {
        setCurrentImage(0);
        setViewerIsOpen(false);
        console.log("CLOSING CAROSEL");
    }, []);

    const getConfigurableProps = () => ({
        showArrows: true,
        showStatus: true,
        showIndicators: true,
        infiniteLoop: true,
        showThumbs: true,
        useKeyboardArrows: true,
        autoPlay: true,
        stopOnHover: true,
        swipeable: true,
        dynamicHeight: true,
        emulateTouch: true,
        autoFocus: false,
        thumbWidth: 100,
        selectedItem: 0,
        interval: 2000,
        transitionTime: 500,
        swipeScrollTolerance: 5,
        ariaLabel: undefined
    });

    if (allowRender) {
        return (
            <React.Fragment>
                <ReactPhotoCollageComponent
                    width={width}
                    height={height}
                    layout={layout}
                    layoutPhotoMaps={layoutPhotoMaps}
                    layoutNum={layoutNum}
                    remainingNum={remainingNum}
                    showNumOfRemainingPhotos={showNumOfRemainingPhotos}
                    openLightbox={openLightbox}
                />
                {/* {
                    viewerIsOpen ?
                        (
                            <Carousel {...getConfigurableProps()}>
                                <div>
                                    {
                                        photos.map((data, i) => {
                                            return (
                                                <div key={i}>
                                                    <img src='./test.jpg' />
                                                    <p className="legend">{data.shortInfo}</p>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </Carousel>
                            // <Carousel {...getConfigurableProps()}>
                            //     <div key="0">
                            //         <img src="tet.jpg" />
                            //         <p className="legend">photo</p>
                            //     </div>
                            // </Carousel>
                        ) : null
                } */}
                <ModalGateway>
                    {
                        viewerIsOpen ?
                            (
                                <Modal onClose={closeLightbox}>
                                    <Carousel views={photos} currentIndex={currentImage} sliderBg="#000"/>
                                </Modal>
                            ) : null
                    }
                </ModalGateway>
            </React.Fragment>
        );
    }

    return null;
}

export default ReactPhotoCollageContainer;


// WEBPACK FOOTER //
// ./src/Components/react-photo-collage/react-photo-collage-container.js